import React, { useEffect, useState } from 'react'
import useWindowDimensions from '../hooks/useDimensions'
import { Dropdown } from 'primereact/dropdown'
import apis, { getAbsenceDays } from '../../api'
import SkeletonTable from '../SkeletonTable/SkeletonTable'
import { Card } from 'primereact/card';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Chart } from 'primereact/chart'
import { Toolbar } from 'primereact/toolbar'
import { Avatar } from 'primereact/avatar'
import { Badge } from 'primereact/badge'
import { Tooltip } from 'primereact/tooltip'
import './Dashboard.css'
import { DataView } from 'primereact/dataview'
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import InfoIcon from '../InfoIcon/InfoIcon'

const Dashboard = () => {

    const name = localStorage.getItem("name")

    const { width, height } = useWindowDimensions()

    const dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };

    const today = new Date(Date.now()).toLocaleDateString('es-CO', dateOptions)

    const headers = {
        authorization: localStorage.getItem('token')
    }

    const entity = localStorage.getItem('entity')
    const client = localStorage.getItem('client')

    /*Propiedades de la tabla del componente*/
    const [rowDataTime, setRowDataTime] = useState([]);
    const [rowsTime, setRowsTime] = useState([]);
    const [first2Time, setFirst2Time] = useState(0);
    const [rows2Time, setRows2Time] = useState(10);
    const [selectedRowsTime, setSelectedRowsTime] = useState(null);
    const [filters1, setFilters1] = useState("");
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [rowDataAcumulate, setRowDataAcumulate] = useState([]);
    const [rowsAcumulate, setRowsAcumulate] = useState([]);
    const [rowsAcumulateFilter, setRowsAcumulateFilter] = useState([]);
    const [first2Acumulate, setFirst2Acumulate] = useState(0);
    const [rows2Acumulate, setRows2Acumulate] = useState(2);
    const [selectedRowsAcumulate, setSelectedRowsAcumulate] = useState(null);

    const [rowDataBirthday, setRowDataBirthday] = useState([]);
    const [rowsBirthday, setRowsBirthday] = useState([]);
    const [rowsBirthdayFilter, setRowsBirthdayFilter] = useState([]);
    const [first2Birthday, setFirst2Birthday] = useState(0);
    const [rows2Birthday, setRows2Birthday] = useState(7);
    const [selectedRowsBirthday, setSelectedRowsBirthday] = useState(null);

    const [rowDataSchedule, setRowDataSchedule] = useState([]);
    const [rowsSchedule, setRowsSchedule] = useState([]);
    const [rowsScheduleFilter, setRowsScheduleFilter] = useState([]);
    const [first2Schedule, setFirst2Schedule] = useState(0);
    const [rows2Schedule, setRows2Schedule] = useState(2);
    const [selectedRowsSchedule, setSelectedRowsSchedule] = useState(null);

    const [week, setWeek] = useState({
        week: "",
        begin: "",
        end: ""
    })

    const [datasetAbsence, setDatasetAbsence] = useState({
        labels: [],
        datasets: [],
        name: ""
    })

    const [datasetAbsenceFilter, setDatasetAbsenceFilter] = useState({
        labels: [],
        datasets: [],
        name: ""
    })

    const [liveData, setLiveData] = useState({
        ABSENCE: [],
        ACTIVE: [],
        INACTIVE: [],
        VACATION: []
    })

    const [liveDataFilter, setLiveDataFilter] = useState({
        ABSENCE: [],
        ACTIVE: [],
        INACTIVE: [],
        VACATION: []
    })


    const [loadPage, setLoadPage] = useState(false)

    const [isOpenActive, setIsOpenActive] = useState(false)
    const [isOpenVacation, setIsOpenVacation] = useState(false)
    const [isOpenAbsence, setIsOpenAbsence] = useState(false)
    const [isOpenInactive, setIsOpenInactive] = useState(false)
    const [isOpenBirthdays, setIsOpenBirthdays] = useState(false)

    const [entityFilter, setEntityFilter] = useState("")
    const [clientFilter, setClientFilter] = useState("")

    const [entityList, setEntityList] = useState([])
    const [clientList, setClientList] = useState([])
    const [loadingAbsences, setLoadingAbsences] = useState(false)
    const [isFlickering, setIsFlickering] = useState(false)

    useEffect(() => {
        const getAllData = async () => {
            await birthdays()
            await scheduling()
            await employeesNow()
            await schedulingConsolidate()
            await absences()
        }
        getAllData()
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2Birthday = (event) => {
        setFirst2Birthday(event.first);
        setRows2Birthday(event.rows);
    }

    const onCustomPage2Scheduling = (event) => {
        setFirst2Schedule(event.first);
        setRows2Schedule(event.rows);
    }

    const template2 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenActive(true)} />
            )
        },
    };

    const template3 = {
        layout: 'PrevPageLink CurrentPageReport NextPageLink',
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', textAlign: 'center' }} className='text-xs'>
                    {options.first} - {options.last}
                </span>
            )
        },
        'PrevPageLink': (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-none')} onClick={options.onClick} disabled={options.disabled}
                    style={{ height: '1rem', marginRight: '-1rem' }}
                >
                    <i className='pi pi-chevron-left text-xs' />
                </button>
            )
        },
        'NextPageLink': (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-none')} onClick={options.onClick} disabled={options.disabled}
                    style={{ height: '1rem', marginLeft: '-1rem' }}
                >
                    <i className='pi pi-chevron-right text-xs' />
                </button>
            )
        },
    };

    const template4 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenVacation(true)} />
            )
        },
    };

    const template5 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenAbsence(true)} />
            )
        },
    };

    const template6 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenInactive(true)} />
            )
        },
    };

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        console.log(filters1)
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const matchModes = [
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const birthdays = async () => {
        try {
            await apis.getBirthdays(entity, client, headers).then(res => {
                setRowsBirthday(res.data.BIRTHDAYS)
                setRowsBirthdayFilter(res.data.BIRTHDAYS)
                if(res.data.BIRTHDAYS.length > 0){
                    setIsFlickering(true)
                }
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const scheduling = async () => {
        try {
            await apis.getScheduling(entity, client, headers).then(res => {
                setRowsSchedule(res.data.SHEDULES)
                setRowsScheduleFilter(res.data.SHEDULES)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const schedulingConsolidate = async () => {
        try {
            await apis.getSchedulingConsolidate(entity, client, headers).then(res => {
                setRowsAcumulate(res.data.SHEDULES)
                setRowsAcumulateFilter(res.data.SHEDULES)
                setWeek({
                    ...week,
                    begin: res.data.WEEK_INI,
                    end: res.data.WEEK_END,
                    week: res.data.WEEK
                })
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const employeesNow = async () => {
        try {
            await apis.getMyEmployeesNow(entity, client, headers).then(res => {
                let data = res.data
                let newDataActive = []
                let newDataVacation = []
                let newDataAbsence = []
                let newDataInactive = []
                let entity_list = []
                let client_list = []
                data.ACTIVE.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        MARKED: act.REST_DAY !== 'S' ? (act.IN === "1" ? "Si" : act.IN === '2' ? 'Reemplazado' : "No") : 'Descanso',
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataActive.push(newAct)
                })
                data.VACATION.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataVacation.push(newAct)
                })
                data.ABSENCE.forEach((act, index) => {
                    let contingency = act.CONTINGENCY.split('|')
                    let newAct = {
                        ...act,
                        CONTINGENCY_DETAIL: contingency[1],
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataAbsence.push(newAct)
                })
                data.INACTIVE.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataInactive.push(newAct)
                })
                data = {
                    ...data,
                    ACTIVE: newDataActive,
                    VACATION: newDataVacation,
                    ABSENCE: newDataAbsence,
                    INACTIVE: newDataInactive

                }
                // setClientList(client_list)
                setEntityList(entity_list)
                setLiveData(data)
                setLiveDataFilter(data)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
        }
    }

    const absences = async (entity_ = -1, client_ = -1) => {
        setLoadingAbsences(false)
        try {
            await apis.getAbsenceDays(entity, client, headers, entity_, client_).then(res => {
                setDatasetAbsence({ ...datasetAbsence, ...res.data, labels: res.data.label })
                setDatasetAbsenceFilter({ ...datasetAbsence, ...res.data, labels: res.data.label })
            })
        }
        catch (err) {
            console.log(err)
        }
        finally{
            setLoadingAbsences(true)
        }
    }

    const photoBodyTemplate = (rowData) => {
        let photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC
        if (rowData.NAME) {
            return (
                <div className='flex flex-row justify-content-start align-items-center gap-1'>
                    <div
                        style={{
                            width: '50px',
                            height: '50px',
                            minWidth: '50px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            flexShrink: 0
                        }}
                    >
                        <img
                            src={photo}
                            alt=""
                            loading="eager"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                    <div className='flex flex-column ml-2 align-self-center'>
                        <span className='font-bold'>{rowData.NAME}</span>
                        <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                    </div>
                </div>
            );
        }
    }

    let options = {
        plugins: {
            tooltip: {
                position: 'average',
                borderWidth: '100',
                callbacks: {
                    labelTextColor: function (context) {
                        return 'white';
                    },
                    label: function (dataset) {
                        let label = dataset.label
                        let data = dataset.parsed
                        console.log(data)

                        if (label) {
                            label += ': ';
                        }
                        label += data.y;
                        return label;
                    }
                }
            },
            // title: {
            //     display: true,
            //     text: datasetAbsence.name,
            //     color: 'black',
            //     font: {
            //         size: '20',
            //     },
            //     padding: {
            //         top: 0
            //     }
            // },
            legend: {
                align: 'center',
            }
        }
    }

    const startToolbarTemplate = () => {
        return (
            <div className='flex align-content-center gap-3'>
                <label className='flex align-self-center'>Semana {week.week}</label>
            </div>
        )
    }

    const endToolbarTemplate = () => {
        return (
            <div className='flex align-content-center gap-3'>
                <label className='flex align-self-center'>{week.begin} a {week.end}</label>
            </div>
        )
    }

    const employeeTemplate = (employee, type) => {
        let tooltip = employee.CONTRACT_ID + '\n' + employee.NAME + '\n' + employee.JOB_ID + '\nEmpresa: ' + employee.ENTITY_NAME + '\nCliente: ' + employee.CLIENT_NAME
        let func
        switch (type) {
            case 'active':
                const marked = employee.REST_DAY !== 'S' ? (employee.IN === '1' ? 'Ingresado' : employee.IN === '2' ? 'Reemplazado' : 'No ingresado') : "Descanso"
                tooltip = tooltip + '\n' + marked
                func = () => setIsOpenActive(true)
                break;
            case 'vacation':
                func = () => setIsOpenVacation(true)
                break;
            case 'absence':
                tooltip = tooltip + '\n' + employee.CONTINGENCY_DETAIL
                func = () => setIsOpenAbsence(true)
                break;
            case 'inactive':
                func = () => setIsOpenInactive(true)
                break;
        }
        if (employee.INDEX === 5) {
            return (
                <>
                    <Tooltip target=".custom-target-icon" style={{ maxWidth: '16rem' }} />
                    <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" label='+' shape="circle"
                        data-pr-tooltip="Ver más"
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        onClick={func}
                    >
                    </Avatar>
                </>
            )
        }
        return (
            <>
                <Tooltip target=".custom-target-icon" style={{ maxWidth: '16rem' }} />
                <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" image={employee.IMAGES} shape="circle"
                    data-pr-tooltip={tooltip}
                    data-pr-position="left"
                    data-pr-at="left+5 top"
                    data-pr-my="right center-2"
                >
                    {type === 'active' && <Badge className={employee.REST_DAY === 'S' && 'resting'} 
                    severity={employee.REST_DAY !== 'S' && (employee.IN === '1' ? 'success' : employee.IN === '2' ? 'warning' : 'danger')} />}
                </Avatar>
            </>
        )
    }

    const employeeTableTemplate = (employee, type) => {
        return (
            <div className='flex flex-row justify-content-start align-items-center gap-1'>
                <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" image={employee.IMAGES} shape="circle" >
                    {type === 'active' && 
                    <Badge className={employee.REST_DAY === 'S' && 'resting'} 
                    severity={employee.REST_DAY !== 'S' && (employee.IN === '1' ? 'success' : employee.IN === '2' ? 'warning' : 'danger')} />}
                </Avatar>
                <div className='flex flex-column ml-2 align-self-center'>
                    <span className='font-bold'>{employee.NAME}</span>
                    <span>{employee.CONTRACT_ID} - {employee.JOB_ID}</span>
                    <span><span className='font-bold'>Empresa: </span>{employee.ENTITY_NAME}</span>
                    <span><span className='font-bold'>CLIENTE: </span>{employee.CLIENT_NAME}</span>
                </div>
            </div>
        )
    }

    const titleTemplate = (title) => {
        const title_ = <span style={{ maxWidth: '7rem', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} >{title}</span>
        return (
            <Toolbar className='titlebar w-full font-bold flex text-center' center={(title.length > 10 && ((width <= 1024 && width > 768) || width <= 375)) ? title_ : title}
                style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }}
            />
        )
    }

    const birthdayHeader = [
        <>
            <i className='pi pi-gift text-xs'></i> Cumpleaños del mes <i className='pi pi-gift text-xs'></i>
        </>
    ]    

    const rightToolbarTemplate = () => {
        const msg = "Para filtrar la información, seleccione una empresa.\n Esto habilitará los clientes pertenecientes a dicha empresa\n y se podrá realizar el filtro por ambos campos"
        return(
            <div>
                <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                <Button className={`p-button-xs text-md ${isFlickering ? 'flickering' : ''}`} style={{backgroundColor: 'white', color: 'rgba(16, 97, 162, 1)'}} icon='pi pi-gift' label='Ver cumpleaños' onClick={() => {setIsFlickering(false); setIsOpenBirthdays(true)}} color='white'/>
                &nbsp;
                <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                    data-pr-classname="text-primary" style={{ color: 'white', fontSize: '1.2rem' }} />
                &nbsp;
                <Dropdown value={entityFilter} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                    placeholder="Empresa" style={{ width: '15rem' }} tooltip={entityFilter?.NAME} tooltipOptions={{position: 'top'}}/>
                &nbsp;
                <Dropdown value={clientFilter} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entityFilter}
                    placeholder="Cliente" style={{ width: '15rem' }} tooltip={clientFilter?.NAME} tooltipOptions={{position: 'top'}}/>
            </div>
        )
    }

    const leftToolbarTemplate = () => {
        return(
            <div className='flex flex-column justify-content-center align-items-start gap-1'>
                <span className='w-full'>Bienvenido(a), <span className='w-full font-bold'>{name}</span></span>
                &nbsp;
                <span>{today}</span>
            </div>
        )
    }

    const applyFilters = (entity_, client_) => {
        let filteredLiveData = {};
        let filteredBirthdays = [...rowsBirthday];
        let filteredAcumulate = [...rowsAcumulate];
        let filteredSchedule = [...rowsSchedule];
    
        Object.keys(liveData).forEach(key => {
            filteredLiveData[key] = liveData[key].filter(item => {
                const matchEntity = entity_
                    ? String(item.ENTITY) === String(entity_.CODE)
                    : true;
    
                const matchClient = client_
                    ? String(item.CLIENT) === String(client_.CODE)
                    : true;
    
                return matchEntity && matchClient;
            });
            let newData = []
            filteredLiveData[key].forEach((item, index) => {
                console.log(index)
                let newItem = {
                    ...item,
                    INDEX: index
                }
                newData.push(newItem)
            })
            filteredLiveData[key] = [...newData]
        });

    
        filteredBirthdays = filteredBirthdays.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });
    
        filteredAcumulate = filteredAcumulate.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });
    
        filteredSchedule = filteredSchedule.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });

        console.log(filteredLiveData)

        let absenceEntity = entity_ ? entity_.CODE : -1 

        let absenceClient = client_ ? client_.CODE : -1 

        absences(absenceEntity, absenceClient)
    
        setLiveDataFilter({ ...filteredLiveData });
        setRowsBirthdayFilter(filteredBirthdays);
        setRowsAcumulateFilter(filteredAcumulate);
        setRowsScheduleFilter(filteredSchedule);
    };

    const filterByEntity = (entity_) => {
        setEntityFilter(entity_);
        setClientFilter("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(entity_, entity_  ? clientFilter : undefined);
    };

    const filterByClient = (client_) => {
        setClientFilter(client_);
        applyFilters(entityFilter, client_ ? client_ : undefined);
    };
    
    return (
        <div style={{ width: '100%' }} className=' mt-6'>
            <SkeletonTable load={loadPage} width='100%'>
                <div className="flex flex-column justify-content-center align-items-center w-full" style={{}}>
                    <Tooltip target=".info" />
                    <Toolbar className="w-full mt-6 "style={{maxWidth: 'none !important', background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }} 
                        start={leftToolbarTemplate} end={rightToolbarTemplate}/>
                    <div className='flex' style={{width: '100%', flexDirection: width <= 768 ? 'column' : 'row', paddingRight: 5, paddingLeft: 5}}>
                        <Dialog header="Programado" visible={isOpenActive} position="top"
                            draggable={false} resizable={false} modal onHide={() => setIsOpenActive(!isOpenActive)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.ACTIVE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'active')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                                <Column header="Ingreso" field='MARKED' filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header="Vacaciones" visible={isOpenVacation} position="top"
                            draggable={false} resizable={false} modal onHide={() => setIsOpenVacation(!isOpenVacation)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.VACATION}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'vacation')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header="Ausentismos" visible={isOpenAbsence} position="top"
                            draggable={false} resizable={false} modal onHide={() => setIsOpenAbsence(!isOpenAbsence)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.ABSENCE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'absence')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                                <Column header="Contingencia" field='CONTINGENCY_DETAIL' filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header="Sin programación" visible={isOpenInactive} position="top"
                            draggable={false} resizable={false} modal onHide={() => setIsOpenInactive(!isOpenInactive)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.INACTIVE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'inactive')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header={birthdayHeader} visible={isOpenBirthdays} position="top"
                            draggable={false} resizable={false} modal onHide={() => setIsOpenBirthdays(!isOpenBirthdays)}>
                            <DataTable className="card text-xs h-full" value={rowsBirthdayFilter} paginator paginatorTemplate={template3} first={first2Birthday} rows={rows2Birthday}
                                onPage={onCustomPage2Birthday} dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '34rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column field="NUMBER_ID" header="Empleado" body={photoBodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                                <Column field="BIRTHDAY" header="Día" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                                <Column field="ENTITY_NAME" header="Empresa" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por empresa" sortable></Column>
                                <Column field="CLIENT_NAME" header="Cliente" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por cliente" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <div className='flex flex-column' style={{ width: width > 768 ? '50vw' : '100%' }}>
                            <div className='flex flex-row w-full text-xs'>
                                <Card header={titleTemplate('Programado')} style={{ width: "50%", height: width > 768 ? '25vh' : '28vh' }}
                                    className='card flex justify-content-start'
                                >
                                    {liveDataFilter.ACTIVE.length > 0 &&
                                        <>
                                            <DataView value={liveDataFilter.ACTIVE} itemTemplate={(item) => employeeTemplate(item, 'active')} className={width <= 1024 && width > 768 && '-mt-4'}
                                                paginatorClassName='text-xs border-none' paginator paginatorTemplate={template2} layout={'grid'} rows={6} />
                                        </>
                                    }
                                </Card>
                                <Card header={titleTemplate('Vacaciones')} style={{ width: "50%", height: width > 768 ? '25vh' : '28vh' }}
                                    className='card flex justify-content-start'
                                >
                                    {liveDataFilter.VACATION.length > 0 &&
                                        <>
                                            <DataView value={liveDataFilter.VACATION} itemTemplate={(item) => employeeTemplate(item, 'vacation')} className={width <= 1024 && width > 768 && '-mt-4'}
                                                paginatorClassName='text-xs border-none' paginator paginatorTemplate={template4} layout={'grid'} rows={6} />
                                        </>
                                    }
                                </Card>
                            </div>
                            <Toolbar className='card flex flex-row bg-white w-full max-w-full' start={startToolbarTemplate} end={endToolbarTemplate}
                                style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }}
                            />
                            <Card className='newCard card flex align-content-start' style={{ height: '52.5vh' }}>

                                <DataTable className="card text-xs w-full" value={rowsAcumulateFilter} rows={rows2Acumulate} dataKey="NUMBER_ID" size="small"
                                    header='Horas y recargos de la semana acumulado' paginator paginatorTemplate={template3} first={first2Acumulate}
                                >
                                    <Column field="ENTITY_NAME" header="Empresa"></Column>
                                    <Column field="CLIENT_NAME" header="Cliente"></Column>
                                    <Column field="RDF" header="RDF"></Column>
                                    <Column field="RN" header="RN"></Column>
                                    <Column field="RNF" header="RNF"></Column>
                                    <Column field="HED" header="HED"></Column>
                                    <Column field="HEN" header="HEN"></Column>  
                                    <Column field="HENF" header="HENF"></Column>
                                    <Column field="TOTAL_RN" header="Total RN"></Column>
                                    <Column field="TOTAL_HE" header="Total HE"></Column>
                                </DataTable>
                                <DataTable className="card text-xs w-full" value={rowsScheduleFilter} paginator paginatorTemplate={template3} first={first2Schedule} rows={rows2Schedule}
                                    onPage={onCustomPage2Scheduling} dataKey="NUMBER_ID"
                                    size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "30vh"}
                                    globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                                    header='Horas y recargos de la semana acumulados por empleado'
                                >
                                    <Column field="NUMBER_ID" header="Empleado" body={photoBodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                                    <Column field="ENTITY_NAME" header="Empresa"></Column>
                                    <Column field="CLIENT_NAME" header="Cliente"></Column>
                                    <Column field="RDF" header="RDF"></Column>
                                    <Column field="RN" header="RN"></Column>
                                    <Column field="RNF" header="RNF"></Column>
                                    <Column field="HED" header="HED"></Column>
                                    <Column field="HEN" header="HEN"></Column>
                                    <Column field="HENF" header="HENF"></Column>
                                    <Column field="TOTAL_RN" header="Total RN"></Column>
                                    <Column field="TOTAL_HE" header="Total HE"></Column>
                                </DataTable>
                            </Card>
                        </div>
                        <div className='flex flex-column' style={{ width: width > 768 ? '50vw' : '100%' }}>
                            <div className='flex flex-row w-full text-xs'>
                                <Card header={titleTemplate('Ausentimos')} style={{ width: "50%", height: width > 768 ? '25vh' : '28vh' }}
                                    className='card flex justify-content-start'
                                >
                                    {liveDataFilter.ABSENCE.length > 0 &&
                                        <>
                                            <DataView value={liveDataFilter.ABSENCE} itemTemplate={(item) => employeeTemplate(item, 'absence')} className={width <= 1024 && width > 768 && '-mt-4'}
                                                paginatorClassName='text-xs border-none' paginator paginatorTemplate={template5} layout={'grid'} rows={6} /><br />
                                        </>
                                    }
                                </Card>
                                <Card header={titleTemplate('Sin programación')} style={{ width: "50%", height: width > 768 ? '25vh' : '28vh' }}
                                    className='card flex justify-content-start'
                                >
                                    {liveDataFilter.INACTIVE.length > 0 &&
                                        <>
                                            <DataView value={liveDataFilter.INACTIVE} itemTemplate={(item) => employeeTemplate(item, 'inactive')} className={width <= 1024 && width > 768 && '-mt-4'}
                                                paginatorClassName='text-xs border-none' paginator paginatorTemplate={template6} layout={'grid'} rows={6} /><br />
                                        </>

                                    }
                                </Card>
                            </div>
                            <SkeletonTable load={loadingAbsences} width='100%'>
                                <Card className='card' header={titleTemplate(datasetAbsenceFilter.name)} style={{ height: width > 768 ? '60vh' : '65vh', width: width > 768 ? '50vw' : '100%' }}>
                                    <Chart type="line" data={datasetAbsenceFilter} options={options} width={width > 768 ? '40vw' : '100%'} />
                                </Card>
                            </SkeletonTable>
                        </div>
                    </div>
                </div>
            </SkeletonTable>
        </div>
    )
}

export default Dashboard